<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M16,1.5C16,0.67,15.33,0,14.5,0C14.09,0,13.71,0.17,13.44,0.44C13.44,0.44,9.91,3.97,9.91,3.97C9.91,3.97,2,1,2,1C2,1,1,3,1,3C1,3,6.93,6.95,6.93,6.95C6.93,6.95,3.88,10,3.88,10C3.88,10,1,10,1,10C1,10,0,11,0,11C0,11,3,13,3,13C3,13,5,16,5,16C5,16,6,15,6,15C6,15,6,12.12,6,12.12C6,12.12,9.05,9.07,9.05,9.07C9.05,9.07,13,15,13,15C13,15,15,14,15,14C15,14,12.03,6.09,12.03,6.09C12.03,6.09,15.56,2.56,15.56,2.56C15.83,2.29,16,1.91,16,1.5C16,1.5,16,1.5,16,1.5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Airplane',
} as DefineComponent
</script>
